import { useEffect } from 'react';
import { useDashboardStore } from '../store/dashboard.store';
import { DashboardHeader } from './DashboardHeader';
import { DashboardSummaryCards } from './DashboardSummaryCards';
import { SalesTrendChart } from './charts/SalesTrendChart';
import { SalesByStatusChart } from './charts/SalesByStatusChart';
import { CampaignBreakdownChart } from './charts/CampaignBreakdownChart';
import { TopAgentsChart } from './charts/TopAgentsChart';
import { PayReportsSection } from './PayReportsSection';

export const HRDashboardView: React.FC = () => {
  const { metrics, payMetrics, isLoading, error, fetchDashboardMetrics, fetchPayMetrics } = useDashboardStore();

  useEffect(() => {
    fetchDashboardMetrics();
    fetchPayMetrics();
  }, [fetchDashboardMetrics, fetchPayMetrics]);

  if (error) {
    return (
      <div className="p-6">
        <DashboardHeader />
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <p className="text-red-800 font-medium">Error loading dashboard</p>
          <p className="text-red-600 text-sm mt-1">{error}</p>
        </div>
      </div>
    );
  }

  if (isLoading && !metrics) {
    return (
      <div className="p-6">
        <DashboardHeader />
        <div className="bg-white rounded-lg shadow p-12 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="text-gray-600 mt-4">Loading dashboard data...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <DashboardHeader />

      {metrics && (
        <>
          {/* Summary Cards */}
          <DashboardSummaryCards summary={metrics.summary} />

          {/* Sales Charts */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
            <SalesTrendChart data={metrics.salesTrend} />
            <SalesByStatusChart data={metrics.salesByStatus} />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
            <CampaignBreakdownChart data={metrics.campaignBreakdown} />
            <TopAgentsChart data={metrics.topAgents} />
          </div>

          {/* Pay Reports Section */}
          <PayReportsSection payMetrics={payMetrics} />
        </>
      )}
    </div>
  );
};
